
	import { Component, Prop, Vue } from 'vue-property-decorator'

	@Component
	export default class ConfirmDialog extends Vue {
        @Prop({ type: String}) private  msg!: string
		@Prop({ type: Boolean }) private showDialog!: boolean

		private agree() {
            this.$emit('result',  true)
		}

		private disagree() {
            this.$emit('result',  false )
        }

	}
